<template>
    <!-- <form-wizard ref="formwizard" > -->
    <v-container>
        <div class="container-fluid">
            <h3>Registration Huang Yi</h3>
            <v-form lazy-validation ref="formValid" v-model="formValid">
                <div class="row">
                    <div class="form-group col-md">
                        <v-text-field v-model="formData.nomor_huangyi" label="Huang Yi Number / No. Huang Yi 黄衣序号"
                            required :disabled="NoHuangYiDisabled" :rules="mandatoryRules"
                            v-on:keyup="nomorHuangyiHandler"></v-text-field>
                    </div>
                </div>
                <div class="row form-group" style="min-height: ">
                    <div class="col-md-2">
                        <v-avatar size="100px" v-ripple v-if="!url" class="grey lighten-3 mb-3">
                        </v-avatar>
                        <v-avatar size="100px" v-ripple v-else class="mb-3">
                            <v-img :src="url"></v-img>
                        </v-avatar>
                    </div>
                    <div class="col" style="align-content: bottom; display: flex;">
                        <v-file-input @change="Preview_image" v-model="formData.url_photo"
                            placeholder="Upload Your Photo / Upload Foto (上传照片)" style="max-height: 100px"
                            class="fileInput" id="file" ref="file" :rules="rulesImage" :disabled="IfNomornotValid">
                        </v-file-input>
                    </div>
                </div>
                <!--  <div class="row">
                        <div class="form-group col-md">
                            <v-select
                                :items="listKota"
                                label="Registration City / Kota 导引城市"
                                required 
                                item-text="DESKRIPSI_DATA"
                                item-value="ID_DATA"
                                v-model="formData.kota"
                                :rules="mandatoryRules"
                              
                            ></v-select>
                        </div>
                    </div> -->
                <!-- :disabled="statusEdit" -->
                <div class="row">
                    <div class="form-group col-md">
                        <v-text-field v-model="formData.identitas" label="Identity Number / No. Identitas (身份號碼)"
                            required :disabled="IfNomornotValid"></v-text-field>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md">
                        <v-text-field v-model="formData.pinyin"
                            label="Chinese Name (Pinyin) / Nama Mandarin 中文名字 (汉语拼音)*" required
                            :disabled="IfNomornotValid"></v-text-field>
                    </div>
                    <div class="form-group col-md">
                        <v-text-field v-model="formData.nama" label="Name 名字*" required :rules="namaRules"
                            :disabled="IfNomornotValid"></v-text-field>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <v-text-field v-model="formData.hanzi" label="Chinese Name (Hànzì) / Nama Mandarin 中文名字 (汉字)*"
                            required :disabled="IfNomornotValid"></v-text-field>
                    </div>
                    <div class="form-group col-md-3">
                        <v-select :items="listSuku" label="Tribe / Suku (民族)" required v-model="formData.suku"
                            :disabled="IfNomornotValid" item-text="DESKRIPSI_DATA" item-value="ID_DATA"></v-select>
                    </div>
                    <div class="form-group col-md-3">
                        <v-select :items="listGoldar" label="Blood Type / Golongan Darah 血型" required
                            v-model="formData.goldar" :disabled="IfNomornotValid" item-text="DESKRIPSI_DATA"
                            item-value="ID_DATA"></v-select>
                    </div>
                </div>
                <div class="row">
                    Tempat/Tanggal Lahir 出生地/出生日期*
                </div>
                <div class="row">
                    <div class="form-group col">
                        <v-text-field v-model="formData.kota_lahir" label="Place of Birth / Tempat Lahir 出生地" required
                            :disabled="IfNomornotValid"></v-text-field>
                    </div>
                    <div class="form-group col">
                        <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="data_tgl_lahir" label="Date of Birth / Tanggal Lahir 出生日期"
                                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                    @blur="data_tgl_lahir_raw = parseDate(data_tgl_lahir)"></v-text-field>
                            </template>
                            <v-date-picker v-model="data_tgl_lahir_raw" @input="menu3 = false"></v-date-picker>
                        </v-menu>
                    </div>
                    <div class="form-group col">
                        <v-select :items="listStatus" label="Status 婚姻状况*" required v-model="formData.status"
                            :disabled="IfNomornotValid" item-text="DESKRIPSI_DATA" item-value="ID_DATA"></v-select>
                    </div>
                    <div class="form-group col">
                        <!-- <label for="kelamin">Jenis Kelamin 性別*</label> -->
                        <v-radio-group label="Gender / Jenis Kelamin 性别*" v-model="formData.kelamin"
                            :disabled="IfNomornotValid" mandatory column>
                            <v-radio name='formData.kelamin' key="L" label="Man 男" value="L"></v-radio>
                            <v-radio name='formData.kelamin' key="P" label="Woman 女" value="P"></v-radio>
                        </v-radio-group>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md">
                        <v-text-field v-model="formData.prov_dom" label="Residence Province / Provinsi Domisili 居住省"
                            required :disabled="IfNomornotValid"></v-text-field>
                    </div>
                    <div class="form-group col-md">
                        <v-select :items="listKotaTgl" item-text="DESKRIPSI_DATA" item-value="ID_DATA"
                            label="Residence City / Kota Domisili 居住市" required v-model="formData.kota_dom"></v-select>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-3">
                        <v-text-field v-model="formData.kel_dom" label="Residence Village / Kelurahan Domisili 居住村"
                            required :disabled="IfNomornotValid"></v-text-field>
                    </div>
                    <div class="form-group col-md-3">
                        <v-text-field v-model="formData.kodepos_dom" label="Postal Code / Kode Pos 邮政编码" required
                            :disabled="IfNomornotValid"></v-text-field>
                    </div>
                    <div class="form-group col-lg-6">
                        <v-text-field v-model="formData.alamat_dom" label="Residence Address / Alamat Domisili 住所地址"
                            required :disabled="IfNomornotValid"></v-text-field>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-3">
                        <v-text-field v-model="formData.hp" label="Phone Number / No. HP 手机号码" required
                            :disabled="IfNomornotValid"></v-text-field>
                    </div>
                    <div class="form-group col-md-3">
                        <v-text-field v-model="formData.no_telp" label="No Telp 电话号码" required></v-text-field>
                    </div>
                    <!--  <div class="form-group col-md-3">
                            <v-text-field
                                v-model="formData.medsos"
                                label="Social Media / Media sosial 社交媒体"
                                required
                                :disabled="IfNomornotValid"
                            ></v-text-field>
                        </div>
                        <div class="form-group col-md-3">
                            <v-text-field
                                v-model="formData.user_medsos"
                                label="User Social Media / Pengguna Media Sosial 用户社交媒体"
                                required
                                :disabled="IfNomornotValid"
                            ></v-text-field>
                        </div> -->
                    <div class="form-group col-md-3">
                        <v-text-field v-model="formData.email" label="Email 电子邮箱" required :disabled="IfNomornotValid">
                        </v-text-field>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col">
                        <v-select :items="listPendidikan" label="Education / Pendidikan 教育程度" required
                            v-model="formData.pendidikan" :disabled="IfNomornotValid" item-text="DESKRIPSI_DATA"
                            item-value="ID_DATA"></v-select>
                    </div>
                    <div class="form-group col">
                        <v-text-field v-model="formData.hobby" label="Hobby / Hobi 爱好" required
                            :disabled="IfNomornotValid"></v-text-field>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col">
                        <v-select :items="listPekerjaan" label="Occupation / Pekerjaan 职业" required
                            v-model="formData.job" :disabled="IfNomornotValid" item-text="DESKRIPSI_DATA"
                            item-value="ID_DATA"></v-select>
                    </div>
                    <div class="form-group col">
                        <v-text-field v-model="formData.telp_job" label="Office Phone Number / Telp. Tempat Kerja 办事处电话"
                            required :disabled="IfNomornotValid"></v-text-field>
                    </div>
                </div>
                <div class="form-group lg">
                    <v-text-field v-model="formData.address_job" label="Office Address / Alamat Tempat Kerja 公司地址"
                        required :disabled="IfNomornotValid"></v-text-field>
                </div>
                <div class="row">
                    <div class="form-group col">
                        <v-select :items="listKotaDaftar" label="Tao Ying City / Kota Tao Ying 导引城市" required
                            v-model="formData.kota_tao" item-text="DESKRIPSI_DATA" item-value="ID_DATA"
                            :disabled="disableTglTaoYing" :rules="mandatoryRules"></v-select>
                    </div>
                    <div class="form-group col">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="data_tgl_daftar" label="Tao Ying Date / Tgl Tao Ying 导引日期"
                                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                    :disabled="disableTglTaoYing"></v-text-field>
                            </template>
                            <v-date-picker v-model="data_tgl_daftar" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col">
                        <v-select :items="listKotaDaftar" label="Kota Pelantikan 黄衣升级典礼之城" required
                            v-model="formData.kota_pelantikan" item-text="DESKRIPSI_DATA" item-value="ID_DATA">
                        </v-select>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col">
                        <v-menu v-model="menu4" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="data_tgl_pelantikan" label="Tanggal Pelantikan 黄衣升级典礼日期"
                                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                    @blur="data_tgl_pelantikan_raw = parseDate(data_tgl_pelantikan)">
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="data_tgl_pelantikan_raw" @input="menu4 = false"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
                <div class="row">
                    <div v-show="statusEdit" class="row">
                        <div class="form-group col">
                            <v-select :items="listWith"
                                label="Together with you to HICH / Ikut dengan siapa ke HICH 黄衣聚会介绍人 HICH"
                                v-model="formData.with_who" :disabled="IfNomornotValid" item-text="DESKRIPSI_DATA"
                                item-value="ID_DATA"></v-select>
                        </div>
                        <div class="form-group col">
                            <v-text-field v-model="formData.name_with" label="Name 名字" :disabled="IfNomornotValid">
                            </v-text-field>
                        </div>
                        <div class="form-group col">
                            <v-checkbox v-if="this.$session.get('role')!='5'" v-model="formData.anggota_zheng_dao"
                                label="Are they the member of Zheng Dao Li Shang Hu ? / Apakah member Zheng Dao Li Shang Hu ? 是否正道李尚湖道友？">
                            </v-checkbox>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <v-spacer></v-spacer>
                    <div class="col">
                        <v-btn style="margin:10px;float:right;background-color: #E12B38"
                            v-if="this.$session.get('role')!='5'" @click="onClose">Close</v-btn>
                        <v-btn style="margin:10px;float:right;background-color: #FCC133" @click="onReset">Clear</v-btn>
                        <v-btn style="margin:10px;float:right;background-color: #3EB650" @click="checkFormValidity">
                            Submit</v-btn>
                        <!-- <v-btn style="margin:10px;float:right;background-color: #3EB650"  @click="checkFormValidity">Submit</v-btn> -->


                    </div>
                </div>
            </v-form>

        </div>
    </v-container>
</template>

<script>
import 'fix-date' 
import axios from '@/axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    name: 'FormDaftarHuang',
    components: {
        // FormWizard, TabContent
    },
    props: {
        data: {
            type: Object
        }
    },
    watch:{
        data_tgl_daftar_raw (val) {
            this.data_tgl_daftar = this.formatDate(this.data_tgl_daftar_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
        data_tgl_lahir_raw (val) {
            this.data_tgl_lahir = this.formatDate(this.data_tgl_lahir_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
        data_tgl_pelantikan_raw(val) {
            this.data_tgl_pelantikan = this.formatDate(this.data_tgl_pelantikan_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
    },
    // mixins: [ValidationHelper],
    data(){
        return {
            formData:{
                url_photo: null,
                negara: null,
                pinyin: null,
                nama: null,
                hanzi: null,
                suku: null,
                goldar: null,
                kota_lahir: null,
                tgl_lahir: '01-01-1900',
                status: null,
                kelamin: null,
                prov_dom: null,
                kota_dom: null,
                kel_dom: null,
                kodepos_dom: null,
                alamat_dom: null,
                hp: null,
                medsos: null,
                email: null,
                pendidikan: null,
                hobby: null,
                job:null,
                telp_job:null,
                address_job:null,
                motif:null,
                ref_nama:null,
                thn_tao:null,
                kota_tao:null,
                tgl_daftar:'1900-01-01',
                created_by: this.$session.get('user_id'),
                source:'Huangyi',
                foto:null,
                identitas:null,
                with_who:null,
                name_with:null,
                anggota_zheng_dao: null,
                kota_pelantikan:null
            },
            data_tgl_lahir:'',
            data_tgl_lahir_raw:new Date().toISOString().substr(0, 10),
            data_tgl_daftar:'',
            data_tgl_daftar_raw: new Date().toISOString().substr(0, 10),
            data_tgl_pelantikan: '',
            data_tgl_pelantikan_raw: new Date().toISOString().substr(0, 10),
            IfNomornotValid:true,
            NoHuangYiDisabled:false,
            disableTglTaoYing:false,
            dialogLoading:false,
            listKota:[],
            listKotaDaftar:[],
            listGoldar:[],
            listSuku:[],
            listStatus:[],
            listPendidikan:[],
            listPekerjaan:[],
            listKotaTgl:[],
            listWith:[
            {
                'ID_DATA': '1',
                'DESKRIPSI_DATA': 'With Wife' 
            },
            {
                'ID_DATA': '2',
                'DESKRIPSI_DATA': 'With Husband' 
            }],
            // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu2: false,
            menu3: false,
            menu4: false,
            url:null,
            photos:'',
            formValid:true,
            namaRules: [
                v => !!v || 'Nama wajib di-isi',
                v => (v && v.length >= 3) || 'Nama tidak valid' ,
            ],
            mandatoryRules: [
                v => !!v || 'Data wajib di-isi',
            ],
            rulesImage:[
                v => (v && v.size <=600000) || 'Foto maks 600 KB' ,
            ],
            tahunRules: [
                v => !!v || 'Tahun Tao wajib di-isi',
                v => (v && /[0-9]*$/.test(v)) || 'Tahun Tao tidak valid',
            ],
            statusEdit:true
        }
    },
   mounted: function (){
        //Untuk Master Data (axios)
        if(this.$session.get('role')=='5'){//Khusus Role User Huang Yi
            this.kotaTaoDisabled=false;
            axios({
                method: 'post',
                url: 'huangyi_by_number',
                data: {
                    user_id: this.$session.get('user_id')
                },
                headers: {
                  'Authorization': 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                if(response.data){
                    this.data.editedItem=response.data[0];
                    this.initiateDaftarHuang();
                }
            }).catch(error=>{
                console.log('Error Fetch Data '+error);
            });
        }else{
            this.initiateDaftarHuang();
        }
    },
    methods:{
        initiateDaftarHuang(){
            axios({
                method: 'post',
                url: 'master_data_by_admin',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
                data:{
                    user_id:  this.$session.get('user_id')
                }   
            }).then(response => {
                this.listKota=response.data.Kota_Daftar;
                this.listKotaDaftar=response.data.Kota_Daftar;
                this.listSuku=response.data.Suku;
                this.listStatus=response.data.Status;
                this.listPendidikan=response.data.Pendidikan;
                this.listPekerjaan=response.data.Pekerjaan;
                this.listGoldar=response.data.Golongan_Darah;
                this.listKotaTgl=response.data.Kota_Domisili;
                // this.users=response.data;
                //Jika Edited
                this.statusEdit=true;

                if(typeof this.data.editedItem === 'object' && this.data.editedItem.ID_TRX){//Edited
                    // alert('edit');
                    this.NoHuangYiDisabled=true;
                    this.IfNomornotValid=false;//Nomornya valid
                    this.disableTglTaoYing=true
                    this.formData.nomor_huangyi=this.data.editedItem.NO_HUANGYI;

                    this.statusEdit=true;
                    if(this.data.editedItem.URL_FOTO){
                        // this.formData.url_photo=this.data.editedItem.URL_FOTO;
                        this.url= 'https://zhengdaolishanghu.com/laravel/'+this.data.editedItem.URL_FOTO;
                    }
                    console.log(this.data.editedItem.ID_KOTA)

                    //Form 1
                    // this.formData.kota=this.data.editedItem.ID_KOTA;
                    if(this.data.editedItem.ID_KOTA!==null){
                        this.formData.kota = this.listKota.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_KOTA));
                        this.formData.kota = this.formData.kota.ID_DATA;
                    }

                    this.formData.pinyin=this.data.editedItem.NAMA_PINYIN;          
                    this.formData.hanzi=this.data.editedItem.NAMA_HANZI;   
                    this.formData.identitas=this.data.editedItem.NO_IDENTITAS;   

                    this.formData.nama=this.data.editedItem.NAMA_INDO;          
                    this.formData.kota_lahir=this.data.editedItem.KOTA_LAHIR;          
                    if(this.data.editedItem.KELAMIN==='Perempuan' || this.data.editedItem.KELAMIN==='P')
                    {
                        this.formData.kelamin='P'; 

                    }else{
                        this.formData.kelamin='L'; 
                    }  

                   // this.formData.tgl_lahir=this.data.editedItem.TGL_LAHIR;  
                    this.data_tgl_lahir = new Date(this.data.editedItem.TGL_LAHIR).toLocaleDateString('es-CL');
                    this.data_tgl_lahir_raw = new Date(this.data.editedItem.TGL_LAHIR).toISOString().substr(0, 10); 
                  


                    if(this.data.editedItem.ID_STATUS){
                        this.formData.status = this.listStatus.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_STATUS));
                        this.formData.status = this.formData.status.ID_DATA;  
                    }

                    if(this.data.editedItem.ID_SUKU){
                        this.formData.suku = this.listSuku.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_SUKU));
                        this.formData.suku = this.formData.suku.ID_DATA;   
                    }

                    if(this.data.editedItem.ID_GOLDAR){
                        this.formData.goldar = this.listGoldar.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_GOLDAR));
                        this.formData.goldar = this.formData.goldar.ID_DATA;  
                    }

       
                    //Form 2
                    this.formData.prov_dom=this.data.editedItem.PROP_DOM;         
                    // this.formData.kota_dom=this.data.editedItem.KOTA_DOM;    
                    if(this.data.editedItem.KOTA_DOM){
                        this.formData.kota_dom = this.listKotaTgl.find(item => item.ID_DATA === parseInt(this.data.editedItem.KOTA_DOM));
                        this.formData.kota_dom = this.formData.kota_dom.ID_DATA;  
                    }    
                    if (this.data.editedItem.KOTA_PELANTIKAN) {
                        this.formData.kota_pelantikan = this.listKotaDaftar.find(item => item.ID_DATA === parseInt(this.data.editedItem.KOTA_PELANTIKAN));
                        this.formData.kota_pelantikan = this.formData.kota_pelantikan.ID_DATA;
                    }
                    this.formData.kel_dom=this.data.editedItem.KEL_DOM;        
                    this.formData.kodepos_dom=this.data.editedItem.KODE_POS_DOM;         
                    this.formData.alamat_dom=this.data.editedItem.ALAMAT_DOM; 
                    this.formData.hp=this.data.editedItem.NO_HP;
                    this.formData.no_telp=this.data.editedItem.NO_TELP;
                    this.formData.med_sos=this.data.editedItem.MED_SOS;
                    this.formData.user_medsos=this.data.editedItem.USER_MEDSOS;
                    this.formData.email=this.data.editedItem.EMAIL;
                    this.formData.hobby=this.data.editedItem.HOBBY;      
                    // this.formData.pendidikan =this.data.editedItem.ID_PENDIDIKAN;
                    if(this.data.editedItem.ID_PENDIDIKAN){
                        this.formData.pendidikan = this.listPendidikan.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_PENDIDIKAN));
                        this.formData.pendidikan = this.formData.pendidikan.ID_DATA;  
                    }

                    // //Form 3
                    if(this.data.editedItem.ID_PEKERJAAN){
                        this.formData.job = this.listPekerjaan.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_PEKERJAAN));
                        this.formData.job = this.formData.job.ID_DATA;  
                    }
                    this.formData.telp_job=this.data.editedItem.TELP_KERJA;
                    this.formData.address_job=this.data.editedItem.ALAMAT_KERJA;

                    //Form 4
                    // this.formData.motif=this.data.editedItem.MOTIVASI_TAO;
                    // this.formData.ref_nama=this.data.editedItem.REF_NAMA;
                    // this.formData.thn_tao=this.data.editedItem.THN_TAOING;
                    
                    if(this.data.editedItem.KOTA_TAOYING){
                        this.formData.kota_tao = this.listKotaDaftar.find(item => item.ID_DATA === parseInt(this.data.editedItem.KOTA_TAOYING));
                        this.formData.kota_tao = this.formData.kota_tao.ID_DATA; 
                    } 

                    //this.data_tgl_daftar = this.data.editedItem.TGL_DAFTAR
                    this.data_tgl_daftar = new Date(this.data.editedItem.TGL_DAFTAR).toLocaleDateString('es-CL');
                    this.data_tgl_daftar_raw = new Date(this.data.editedItem.TGL_DAFTAR).toISOString().substr(0, 10); 
                    if (this.data.editedItem.TGL_PELANTIKAN) {
                        this.data_tgl_pelantikan = new Date(this.data.editedItem.TGL_PELANTIKAN).toLocaleDateString('es-CL');
                        this.data_tgl_pelantikan_raw = new Date(this.data.editedItem.TGL_PELANTIKAN).toISOString().substr(0, 10);
                        // this.data_tgl_pelantikan = '';
                        // this.data_tgl_pelantikan_raw = new Date().toISOString().substr(0, 10);                  
                    }

                     if(this.data.editedItem.TAMBAHAN_PESERTA!==null){
                        this.formData.with_who = this.listWith.find(item => parseInt(item.ID_DATA) === parseInt(this.data.editedItem.TAMBAHAN_PESERTA));
                        // console.log(this.listWith)
                        // console.log(this.data.editedItem.TAMBAHAN_PESERTA)
                        // console.log(this.listKotaDaftar)
                         this.formData.with_who = this.formData.with_who.ID_DATA;
                          this.formData.name_with = this.data.editedItem.NAMA_PESERTA; 
                     }else{
                         this.formData.with_who=null;
                           this.formData.name_with=null;
                     }

                    

                    if(this.$session.get('role')=='5'){
                        this.formData.anggota_zheng_dao = true

                    }else{
                        if(this.data.editedItem.FLAG_ANGGOTA)this.formData.anggota_zheng_dao = true;
                        else this.formData.anggota_zheng_dao = false;
                    }
                   
                }else{
                     this.disableTglTaoYing=false
                }
            }).catch(error=>{
                console.log(error)
               // alert('Failed to retireve data !');
                // this.$emit('onCloseDialog');
                // var status = error.response.status
            });
            // console.log(this.data.editedItem);
        },
        formatDate (val) {
            if (!val) 
            {
                return null
            }else{
                return new Date(val).toLocaleDateString('es-CL');

            }
        },
        parseDate (val) {
            if(val!==null && typeof(val)!=='undefined'){ 
                return new Date(val).toISOString().substr(0, 10)
            }else{
                return null
            } 
            
        },
        nomorHuangyiHandler(){
            if((this.formData.nomor_huangyi).length==15 && !this.data.editedItem.ID_TRX){
                // alert(this.formData.nomor_huangyi);
                axios({
                    method: 'post',
                    url: 'cek_nomor_huangyi',
                    data: {
                        nomor_huangyi: this.formData.nomor_huangyi,
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    if(response.data){
                       this.IfNomornotValid=false;//Nomornya valid
                    }else{
                        Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Huang Yi is not valid, Please check the form.'
                        });
                    }
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
                // this.IfNomornotValid=false;//Nomornya valid
            }
        },
        checkFormValidity(){
            this.formValid=false;
            //Check Validity (Kolom yang mandatory, dan Nomor Huang Yi)
            if(this.formData.url_photo !== null && this.$refs.file.validate() === false){
                Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Photo is not valid'
                        });
            }
            else if(this.formData.nama && this.formData.kota_tao && this.formData.hp && this.data_tgl_lahir && this.data_tgl_daftar && this.formData.kota_dom ){
                this.onSubmit();
                //  axios({
                //     method: 'post',
                //     url: 'validate_nomor_huangyi',
                //     data: {
                //         nomor_huanyi: this.formData.nomor_huangyi,
                //         kota_tao: this.formData.kota_tao,
                //         tahun_tao: this.formData.thn_tao,
                //         running_number : (this.formData.nomor_huangyi).substr(-1,6)
                //     },
                //     headers: {
                //       Authorization: 'Bearer ' + this.$session.get('token'),
                //     },
                // }).then(response => {
                //     if(response.data){
                //         this.formValid=true;
                //     }else{
                //         // alert("Nomor Huang Yi dengan isi Form Tidak Valid, Silahkan dicek kembali");
                //         Swal.fire({
                //                 title:'Peringatan',
                //                 icon :'error',
                //                 text:'Huang Yi is not valid, Please check the form.'
                //         });
                //     }
                // }).catch(error=>{
                //     console.log('Error Fetch Data '+error);
                //     // var status = error.response.status
                // });
            }else{
                if(!this.formData.nama)
                {
                     Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Name is not valid'
                        });
                }else if(!this.formData.kota_tao){
                     Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'City/Tao Ying City is not valid'
                        });
                 }else if(!this.formData.hp){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'The Phone Number is not valid'
                        });
                }else if (!this.formData.kota_dom){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Residence City is not valid'
                        });                    
                }else if(!this.data_tgl_daftar){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Tao Ying Date is not valid'
                        }); 
                }else if(!this.data_tgl_lahir){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Date of Birth is not valid'
                        }); 
                }
                 this.formValid=false;
                
            }

            //Final Decision
            if(this.formValid){
                this.onSubmit();
            }
        },
        onSubmit(){

            //Proses pemindahan formdata
            let sendData= new FormData();

            if(this.formData.url_photo){
                sendData.append('foto', this.formData.url_photo);
            }
            
            console.log(this.formData);
            if(this.formData.negara) sendData.append('negara', this.formData.negara);
            if(this.formData.kota) sendData.append('kota', this.formData.kota_tao);
            if(this.formData.url_photo) sendData.append('url_photo', this.formData.url_photo);
            if(this.formData.pinyin) sendData.append('pinyin', this.formData.pinyin);
            if(this.formData.nama) sendData.append('nama', this.formData.nama);
            if(this.formData.hanzi) sendData.append('hanzi', this.formData.hanzi);
            if(this.formData.identitas) sendData.append('no_identitas', this.formData.identitas);
            if(this.formData.suku) sendData.append('suku', this.formData.suku);
            if(this.formData.goldar) sendData.append('goldar', this.formData.goldar);
            if(this.formData.kota_lahir) sendData.append('kota_lahir', this.formData.kota_lahir);
            if(this.formData.tgl_lahir) sendData.append('tgl_lahir', this.formData.tgl_lahir);
            if(this.formData.status) sendData.append('status', this.formData.status);
            if(this.formData.kelamin) sendData.append('kelamin', this.formData.kelamin);
            if(this.formData.prov_dom) sendData.append('prov_dom', this.formData.prov_dom);
            if(this.formData.kota_dom) sendData.append('kota_dom', this.formData.kota_dom);
            if(this.formData.kel_dom) sendData.append('kel_dom', this.formData.kel_dom);
            if(this.formData.kodepos_dom) sendData.append('kodepos_dom', this.formData.kodepos_dom);
            if(this.formData.alamat_dom) sendData.append('alamat_dom', this.formData.alamat_dom);
            if(this.formData.hp) sendData.append('hp', this.formData.hp);
            if(this.formData.no_telp) sendData.append('no_telp', this.formData.no_telp);
            if(this.formData.medsos) sendData.append('medsos', this.formData.medsos);
            if(this.formData.user_medsos) sendData.append('user_medsos', this.formData.user_medsos);
            if(this.formData.email) sendData.append('email', this.formData.email);
            if(this.formData.pendidikan) sendData.append('pendidikan', this.formData.pendidikan);
            if(this.formData.hobby) sendData.append('hobby', this.formData.hobby);
            if(this.formData.job) sendData.append('job', this.formData.job);
            if(this.formData.telp_job) sendData.append('telp_job', this.formData.telp_job);
            if(this.formData.address_job) sendData.append('address_job', this.formData.address_job);
            if(this.formData.thn_tao) sendData.append('thn_tao', this.formData.thn_tao);
            if(this.formData.kota_tao) sendData.append('kota_tao', this.formData.kota_tao);
            if(this.formData.nomor_huangyi) sendData.append('nomor_huangyi', this.formData.nomor_huangyi); //Huang yi diTaoYu akna kosong
            if(this.formData.tgl_daftar) sendData.append('tgl_daftar', this.formData.tgl_daftar);
            // if(this.formData.user_id) sendData.append('user_id', this.formData.user_id);
            if(this.formData.user_id) sendData.append('user_id', this.$session.get('user_id'));
            if(this.formData.source) sendData.append('source', this.formData.source);

            if(this.formData.with_who) sendData.append('with_who', this.formData.with_who);
            if(this.formData.name_with) sendData.append('name_with', this.formData.name_with);
            if (this.formData.anggota_zheng_dao) sendData.append('flag_anggota', 1);
            if (this.formData.kota_pelantikan) sendData.append('kota_pelantikan', this.formData.kota_pelantikan);

            if(this.data_tgl_lahir) sendData.append('tgl_lahir', this.data_tgl_lahir);
            if (this.data_tgl_daftar) sendData.append('tgl_daftar', this.data_tgl_daftar);
            if (this.data_tgl_pelantikan_raw) sendData.append('tgl_pelantikan', this.data_tgl_pelantikan_raw);
            sendData.append('user_id',this.$session.get('user_id'));
            if(this.data.editedItem.ID_TRX){
                //Edit

                // this.formData.id=this.data.editedItem.ID_TRX;
                sendData.append('id', this.data.editedItem.ID_TRX);
                // alert('Edit');
                axios({
                    method: 'post',
                    url: 'update_data_table_2',
                    data: sendData,
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    if(this.$session.get('role')=='5'){
                         Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data+'.\nYou will be logout automatically.'
                        });
                        
                        axios({
                            method: 'post',
                            url: 'update_user_flag',
                            data:{
                                id: this.$session.get('user_id')
                            },
                            headers: {
                              Authorization: 'Bearer ' + this.$session.get('token'),
                            },
                        }).then(response => {
                            
                        }).catch(error => {
                            
                        });
                        this.authenticated = false;
                        this.$session.destroy();
                        this.$router.push('/');

                    }else{
                         Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data
                        });
                        this.$emit('onCloseDialog');
                     //   this.printProfile(this.data.editedItem.ID_TRX,this.formData.nama)
                        console.log(this.$session.get('role'))
                    }
                    // alert(response.data);
                    // this.$emit('onCloseDialog');
                    // console.log(JSON.stringify(response));
                    // this.users=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }else{
                // alert('New');
                //Insert new
                axios({
                    method: 'post',
                    url: 'data_table',
                    data: sendData,
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data.message
                        });
                    this.onReset();
                    this.$emit('onCloseDialog');
                    // console.log(JSON.stringify(response));
                    // this.users=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }
            
        },
        onClose(){
            this.onReset();
            this.data.editedItem.ID_TRX=null
            this.$emit('onCloseDialog');
        },
        onReset(){
            this.formData.foto=null;
            this.formData.negara=null;
            this.formData.pinyin=null;
            this.formData.nama=null;
            this.formData.hanzi=null;
            this.formData.identitas=null;
            this.formData.suku=null;
            this.formData.goldar=null;
            this.formData.kota_lahir=null;
            this.formData.tgl_lahir='1900-01-01';
            this.formData.status=null;
            this.formData.kelamin=null;
            this.formData.prov_dom= null;
            this.formData.kota_dom= null;
            this.formData.kel_dom= null;
            this.formData.kodepos_dom= null;
            this.formData.alamat_dom= null;
            this.formData.hp= null;
            this.formData.no_telp= null;
            this.formData.medsos= null;
            this.formData.email= null;
            this.formData.pendidikan= null;
            this.formData.hobby= null;
            this.formData.job=null;
            this.formData.telp_job=null;
            this.formData.address_job=null;
            this.formData.motif=null;
            this.formData.ref_nama=null;
            this.formData.thn_tao=null;
            this.formData.kota_tao=null;
            this.formData.tgl_daftar='1900-01-01';
            this.formData.created_by= this.$session.get('user_id');
        },
        Preview_image() {

          this.url= URL.createObjectURL(this.formData.url_photo)
        }
    }
}
</script>

<style type="text/css">
    
.fileInput{
    align-self: flex-end;
}  

</style>